import { makeStyles } from '@material-ui/core/styles'

const patientPlotStyle = makeStyles((theme) => ({
    root: {

    },
}))

export default patientPlotStyle